import MyIndividualModelBase from '../_generated/modelBases/my-individual-model-base';

export default class MyIndividualModel extends MyIndividualModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
